module.exports = __webpack_public_path__ + "img/profile_ldf_unterschrift.ad213059.png";